<template>
	<div v-if="$checkPerm('process.cbt.view')">
		<div class="info">
			<p>
				<b>Name: </b> {{cbt.cbtname}}
			</p>
			<p>
				<b>Instructions: </b> {{cbt.instruction}}
			</p>
			<p>
				<b>Time Allowed: </b> {{cbt.time_allowed}} minutes
			</p>
		</div>

		<div v-if="cbt.cbtquestions.length > 0" class="mt-4">
			<h5 class="pb-2">Questions:</h5>
			<div v-for="(question, question_index) in cbt.cbtquestions" class="single_question">
				<b>Question {{question_index + 1}}</b>

				<div v-if="question.questiontype == 'sj'">
					<div class="question-text">
						<p>
							{{question.questioncontent}}
							<b>({{question.score}} mark(s))</b>
						</p>
					</div>
					<div class="question-options">
						<b>Options:</b>
						<ul>
							<li v-for="option in question.options">{{option}}</li>
						</ul>
					</div>
					<div class="question-answers">
						<b>Answers:</b>
						<ul>
							<li v-for="(tag, tag_index) in question.answer_tags">
								<u>{{tag}}:</u> {{ question.options[question.answers[tag_index]] }}
							</li>
						</ul>
					</div>
				</div>

				<div v-else-if="question.questiontype == 'sa'">
					<div class="question-text">
						<p>
							{{question.questioncontent}}
							<b>({{question.score}} marks)</b>
						</p>
					</div>
					<div class="question-options">
						<b>Options:</b>
						<ul>
							<li v-for="option in question.options">{{option}}</li>
						</ul>
					</div>
					<div class="question-answers">
						<b>Answer:</b>
						<span>
							{{ question.options[question.answers[0]] }}
						</span>
					</div>
				</div>

				<div v-else-if="question.questiontype == 'ma' || question.questiontype == 'oa'">
					<div class="question-text">
						<p>
							{{question.questioncontent}}
							<b>({{question.score}} marks)</b>
						</p>
					</div>
					<div class="question-options">
						<b>Options:</b>
						<ul>
							<li v-for="option in question.options">{{option}}</li>
						</ul>
					</div>
					<div class="question-answers">
						<b v-if="question.questiontype == 'ma'">Answers:</b>
						<b v-else>Correct Order</b>
						<ul v-if="question.questiontype == 'ma'">
							<li v-for="(answer, answer_index) in question.answers">
								{{ question.options[question.answers[answer_index]] }}
							</li>
						</ul>
						<ol v-else>
							<li v-for="(answer, answer_index) in question.answers">
								{{ question.options[question.answers[answer_index]] }}
							</li>
						</ol>
					</div>
				</div>

				<div v-else-if="question.questiontype == 'st'">
					<div class="question-text">
						<p>
							{{question.questioncontent}}
							<b>({{question.score}} marks)</b>
						</p>
					</div>
					<div class="question-answers">
						<b>Answers:</b>
						<ul>
							<li v-for="answer in question.answers">
								{{answer}}
							</li>
						</ul>
					</div>
				</div>

				<div v-else>
					<div class="question-text">
						<p>
							{{question.questioncontent}}
						</p>
					</div>
				</div>

			</div>
		</div>
		<div v-else>
			<b>No questions added for this CBT</b>
		</div>
	</div>
</template>
<style type="text/css">
	.single_question {
		border: 1px solid #ccc;
		padding: 20px;
		border-radius: 5px;
		margin-top: 20px;
	}
</style>
<script type="text/javascript">
	export default {
		name: 'ListCbtQuestions',
		props: {
			id: {
				required: true,
				type: Number
			}
		},
		data() {
			return {
				cbt: {
					cbtquestions: []
				}
			}
		},
		methods: {
			getCbt: function () {

				var cbt = {
					what: "ListCBT",
					params: {
						companyid: this.$store.getters.user_data.data.company_id
					}
				}

				this.$socket.makeGetRequest(cbt)
					.then((response) => {
						if (response.type == 'ListCBT') {
							this.cbt = this.sortCbtById(response.data, this.id)
							console.log(this.cbt)
						}
					})
					.catch((error) => {
						console.log(error)
					})
			},
			sortCbtById: function (cbt_array, id) {

				let arr_count = cbt_array.length
				let cbt = []

				for (var i = 0; i < arr_count; i++) {
					if (cbt_array[i].id == id) {
						cbt = cbt_array[i]
						break
					}
				}

				return cbt
			}
		},
		mounted() {
			this.getCbt()
		},
	}
</script>